import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPromises,
  selectIsLoading,
  selectLastPromise,
  selectPromiseCount,
  selectPromiseCounts,
} from "redux-toolkit/promises/selectors";
import {
  getPromisesAsync,
  getNextPromisesAsync,
} from "redux-toolkit/promises/actions";

const usePromises = () => {
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const promises = useSelector(selectPromises);
  const isLoading = useSelector(selectIsLoading);
  const last = useSelector(selectLastPromise);
  const count = useSelector(selectPromiseCount);
  const counts = useSelector(selectPromiseCounts);

  useEffect(() => {
    dispatch(getPromisesAsync());
  }, [dispatch]);

  const getNextPage = () => {
    if (last && count > promises.length) {
      dispatch(getNextPromisesAsync(last));
      setPage(page + 1);
    }
  };

  return {
    promises,
    isLoading,
    hasMoreItems: count > promises.length,
    page,
    setPage,
    getNextPage,
    totalCount: count,
    counts,
  };
};

export default usePromises;
